/* eslint-disable */

import { Card, CardContent, Checkbox, Typography, Grid, Box, Chip, Divider } from "@mui/material";
import { MobXProviderContext } from "mobx-react";
import React, { useEffect } from "react";
import ifoodLogo from "assets/images/ifood_big.png";
import anotaAiLogo from "assets/images/anotaai_big.png";
import aiQFomeLogo from "assets/images/aiqfome_big.png";
import ddLogo from "assets/images/dd_big.png";
import foodyLogo from "assets/images/foody.png";
import pedeProntoLogo from "assets/images/pedepronto_big.png";
import taonLogo from "assets/images/taon.png";
import {
    Smartphone,
    AccessTime,
    LocalShipping,
    CheckCircle,
    Schedule,
    TrendingFlat
} from "@mui/icons-material";


function logoMarketplace(marketplaceId) {
    switch (marketplaceId) {
        case 1:
            return <Smartphone alt="App Próprio" fontSize="large"/>
        case 4:
            return <Box component="img" src={ifoodLogo} alt="iFood" width={40} />;
        case 6:
            return <Box component="img" src={ddLogo} alt="Delivery Direto" width={40} />;
        case 7:
            return <Box component="img" src={aiQFomeLogo} alt="Aiqfome" width={40} />;
        case 8:
            return <Box component="img" src={anotaAiLogo} alt="Anota Aí" width={40} />;
        case 9:
            return <Box component="img" src={pedeProntoLogo} alt="Pede Pronto" width={40} />;
        default:
            return <Smartphone alt="App Próprio" fontSize="large"/>;
    }
}

function formatDataPedido(dataPedido) {
    if (!dataPedido || dataPedido.length !== 14) {
        return "";
    }

    // Parse the date string: YYYYMMDDHHmmss
    const year = dataPedido.substring(0, 4);
    const month = dataPedido.substring(4, 6);
    const day = dataPedido.substring(6, 8);
    const hour = dataPedido.substring(8, 10);
    const minute = dataPedido.substring(10, 12);

    // Check if the date is today
    const today = new Date();
    const pedidoDate = new Date(year, month - 1, day);

    const isToday = today.getDate() === pedidoDate.getDate() &&
                    today.getMonth() === pedidoDate.getMonth() &&
                    today.getFullYear() === pedidoDate.getFullYear();

    const timeString = `${hour}:${minute}`;

    if (isToday) {
        return `Pedido feito às ${timeString}`;
    } else {
        const dateString = `${day}/${month}/${year}`;
        return `Pedido feito às ${timeString} (${dateString})`;
    }
}

function formatTempoEmRota(dataDespacho) {
    if (!dataDespacho || dataDespacho.length !== 14) {
        return { text: "", isDelayed: false };
    }

    // Parse the date string: YYYYMMDDHHmmss
    const year = parseInt(dataDespacho.substring(0, 4));
    const month = parseInt(dataDespacho.substring(4, 6)) - 1;
    const day = parseInt(dataDespacho.substring(6, 8));
    const hour = parseInt(dataDespacho.substring(8, 10));
    const minute = parseInt(dataDespacho.substring(10, 12));
    const second = parseInt(dataDespacho.substring(12, 14));

    const despachoDate = new Date(year, month, day, hour, minute, second);
    const now = new Date();

    // Calculate difference in minutes
    const diffMs = now - despachoDate;
    const diffMinutes = Math.floor(diffMs / 60000);

    if (diffMinutes < 0) {
        return { text: "", isDelayed: false }; // Data futura, não mostrar
    }

    const isDelayed = diffMinutes >= 60; // 60+ minutes is considered delayed
    let text = "";

    if (diffMinutes < 60) {
        text = `A caminho há ${diffMinutes} minuto${diffMinutes !== 1 ? 's' : ''}`;
    } else {
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;
        if (minutes === 0) {
            text = `A caminho há ${hours} hora${hours !== 1 ? 's' : ''}`;
        } else {
            text = `A caminho há ${hours}h${minutes}min`;
        }
    }

    return { text, isDelayed };
}

function formatDataFinalizacao(dataFinalizacao) {
    if (!dataFinalizacao || dataFinalizacao.length !== 14) {
        return "";
    }

    // Parse the date string: YYYYMMDDHHmmss
    const year = dataFinalizacao.substring(0, 4);
    const month = dataFinalizacao.substring(4, 6);
    const day = dataFinalizacao.substring(6, 8);
    const hour = dataFinalizacao.substring(8, 10);
    const minute = dataFinalizacao.substring(10, 12);

    // Check if the date is today
    const today = new Date();
    const finalizacaoDate = new Date(year, month - 1, day);

    const isToday = today.getDate() === finalizacaoDate.getDate() &&
                    today.getMonth() === finalizacaoDate.getMonth() &&
                    today.getFullYear() === finalizacaoDate.getFullYear();

    const timeString = `${hour}:${minute}`;

    if (isToday) {
        return `Finalizado às ${timeString}`;
    } else {
        const dateString = `${day}/${month}/${year}`;
        return `Finalizado às ${timeString} (${dateString})`;
    }
}

function formatDetalhesPedidoFinalizado(dataPedido, dataDespacho, dataFinalizacao) {
    if (!dataFinalizacao || dataFinalizacao.length !== 14) {
        return null;
    }

    const parseDateTime = (dateString) => {
        if (!dateString || dateString.length !== 14) return null;
        const year = parseInt(dateString.substring(0, 4));
        const month = parseInt(dateString.substring(4, 6)) - 1;
        const day = parseInt(dateString.substring(6, 8));
        const hour = parseInt(dateString.substring(8, 10));
        const minute = parseInt(dateString.substring(10, 12));
        const second = parseInt(dateString.substring(12, 14));
        return new Date(year, month, day, hour, minute, second);
    };

    const formatTime = (dateString) => {
        if (!dateString || dateString.length !== 14) return null;
        return `${dateString.substring(8, 10)}:${dateString.substring(10, 12)}:${dateString.substring(12, 14)}`;
    };

    const calculateDuration = (startDate, endDate) => {
        if (!startDate || !endDate) return null;
        const diffMs = endDate - startDate;
        const diffMinutes = Math.floor(diffMs / 60000);

        if (diffMinutes < 60) {
            return `${diffMinutes} minuto${diffMinutes !== 1 ? 's' : ''}`;
        } else {
            const hours = Math.floor(diffMinutes / 60);
            const minutes = diffMinutes % 60;
            if (minutes === 0) {
                return `${hours} hora${hours !== 1 ? 's' : ''}`;
            } else {
                return `${hours}h${minutes}min`;
            }
        }
    };

    const pedidoDate = parseDateTime(dataPedido);
    const despachoDate = parseDateTime(dataDespacho);
    const finalizacaoDate = parseDateTime(dataFinalizacao);

    const pedidoTime = formatTime(dataPedido);
    const despachoTime = formatTime(dataDespacho);
    const finalizacaoTime = formatTime(dataFinalizacao);

    let tempoTotal = null;
    if (despachoDate && finalizacaoDate) {
        tempoTotal = calculateDuration(despachoDate, finalizacaoDate);
    }

    return { pedidoTime, despachoTime, finalizacaoTime, tempoTotal };
}

// Componente visual para exibir a timeline de entrega (horizontal e compacto)
function TimelineEntrega({ pedidoTime, despachoTime, finalizacaoTime, tempoTotal }) {
    const TimelineItem = ({ icon, label, time }) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
            <Box sx={{
                bgcolor: '#2e7d32',
                borderRadius: '50%',
                width: 28,
                height: 28,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                mb: 0.5
            }}>
                {icon}
            </Box>
            <Typography variant="caption" sx={{ color: '#666', fontSize: '0.65rem', textAlign: 'center', mb: 0.3 }}>
                {label}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700, color: '#1a237e', fontSize: '0.8rem' }}>
                {time}
            </Typography>
        </Box>
    );

    return (
        <Box sx={{
            bgcolor: '#f1f8e9',
            borderRadius: 1.5,
            p: 1.5,
            mt: 1,
            border: '1px solid #c5e1a5'
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
                {pedidoTime && (
                    <TimelineItem
                        icon={<AccessTime sx={{ fontSize: 14, color: '#f1f8e9' }} />}
                        label="Início"
                        time={pedidoTime}
                    />
                )}

                {pedidoTime && despachoTime && (
                    <TrendingFlat sx={{ color: '#81c784', fontSize: 20, mb: 3 }} />
                )}

                {despachoTime && (
                    <TimelineItem
                        icon={<LocalShipping sx={{ fontSize: 14, color: '#f1f8e9' }} />}
                        label="Despacho"
                        time={despachoTime}
                    />
                )}

                {despachoTime && finalizacaoTime && (
                    <TrendingFlat sx={{ color: '#81c784', fontSize: 20, mb: 3 }} />
                )}

                {finalizacaoTime && (
                    <TimelineItem
                        icon={<CheckCircle sx={{ fontSize: 14, color: '#f1f8e9'}} />}
                        label="Entregue"
                        time={finalizacaoTime}
                    />
                )}
            </Box>

            {tempoTotal && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1.5, pt: 1, borderTop: '1px dashed #c5e1a5' }}>
                    <Chip
                        icon={<Schedule sx={{ fontSize: 14, color: '#f1f8e9' }} />}
                        label={`Tempo de entrega: ${tempoTotal}`}
                        size="small"
                        sx={{
                            bgcolor: '#2e7d32',
                            color: '#f1f8e9',
                            fontWeight: 700,
                            height: 24,
                            fontSize: '0.7rem',
                            '& .MuiChip-icon': {   color: '#f1f8e9', fontSize: 14 }
                        }}
                    />
                </Box>
            )}
        </Box>
    );
}


function Pedido(props) {
    const { mapaStore } = React.useContext(MobXProviderContext);

    var height = window.innerHeight

    return (
        <div style={{ width: '100%', paddingTop: 4, paddingBot: 2, paddingLeft: 12, paddingRight: 12 }}>

            <Card style={{ width: '100%', border: props.pedido.selected ? "1px solid #669900" : "" }} onClick={() => { mapaStore.toggleSelected(props.pedido) }}>
                <CardContent>
                    <Grid container >
                        {/* <Grid item>
                    <Typography gutterBottom variant="title" component="div">
                        {`${props.pedido.id}`}
                    </Typography>
                </Grid> */}
                        <Grid item xs={12} sm container>
                            <Grid item xs container direction="column" >
                                <Typography gutterBottom variant="h6" component="div">
                                    {`${props.pedido.sequenciaPdv} - ${props.pedido.cliente} (${props.pedido.identificacao})`}
                                </Typography>
                                <Typography variant="body2" gutterBottom>
                                    {`${props.pedido.status}`}
                                </Typography>
                                {props.pedido.dataDespacho && props.pedido.status === "Despachado" && (() => {
                                    const tempoEmRota = formatTempoEmRota(props.pedido.dataDespacho);
                                    return tempoEmRota.text && (
                                        <Typography
                                            variant="body2"
                                            color={tempoEmRota.isDelayed ? "error" : "text.secondary"}
                                            fontWeight="bold"
                                            gutterBottom
                                        >
                                            {tempoEmRota.text}
                                        </Typography>
                                    );
                                })()}
                                {(props.pedido.status === "Entregue" || props.pedido.status === "Entregue/Retornando Origem" || props.pedido.status === "Finalizado") && props.pedido.dataFinalizacao ? (
                                    (() => {
                                        const detalhes = formatDetalhesPedidoFinalizado(
                                            props.pedido.dataPedido,
                                            props.pedido.dataDespacho,
                                            props.pedido.dataFinalizacao
                                        );

                                        if (detalhes) {
                                            return (
                                                <TimelineEntrega
                                                    pedidoTime={detalhes.pedidoTime}
                                                    despachoTime={detalhes.despachoTime}
                                                    finalizacaoTime={detalhes.finalizacaoTime}
                                                    tempoTotal={detalhes.tempoTotal}
                                                />
                                            );
                                        }
                                        return (
                                            <Typography variant="body2" color="text.secondary" gutterBottom>
                                                {formatDataFinalizacao(props.pedido.dataFinalizacao)}
                                            </Typography>
                                        );
                                    })()
                                ) : props.pedido.dataPedido ? (
                                    <Typography variant="body2" color="text.secondary" gutterBottom>
                                        {formatDataPedido(props.pedido.dataPedido)}
                                    </Typography>
                                ) : null}
                                <Typography variant="body2" color="text.secondary">
                                    {`${props.pedido.endereco} `}
                                </Typography>
                                <Typography variant="body2" color={`${props.pedido.entregador.Cor !== "" ? props.pedido.entregador.Cor: 'red'}`} fontWeight="bold" >
                                    {`${props.pedido.entregador.Nome !== undefined ? ' Entregador: ' + props.pedido.entregador.Nome : ''}`}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Checkbox
                                edge="end"
                                onChange={null}
                                checked={props.pedido.selected}
                                inputProps={{ 'aria-labelledby': `checkbox-list-secondary-label-${props.pedido.id}` }}
                                style={{ paddingLeft: 30 }}
                            />
                            <Typography variant="body2" color="text.secondary"  style={{ paddingLeft: 5 }}>
                                {` (${props.pedido.distancia})`}
                            </Typography>
                            {props.pedido.marketplaceId !== 0 ?
                                <Grid container direction="column" justifyContent="center" alignItems="flex-end" style={{ paddingTop: 10 }}>
                                    <Grid item>{logoMarketplace(props.pedido.marketplaceId)}</Grid>
                                    {props.pedido.subIdentificacao !== "" ? <Grid item><Typography variant="h6" component="div">
                                        {`${props.pedido.subIdentificacao}`}
                                    </Typography> </Grid> : <div />}


                                </Grid>
                                : <div />}
                        </Grid>
                    </Grid>

                </CardContent>
            </Card>
        </div>
    )
}

export default Pedido;
